export enum EmailTakenStatus {
  FREE,
  GIK,
  FACEBOOK,
  GOOGLE,
}
